import React from "react";
import * as S from "./styled";
import { generateUrl } from "@/utils/cloudinary";
import PT from "prop-types";

const PortfolioFeedItem = ({ portfolio, ...props }) => {
  const openGallery = () => {
    props.openGallery(portfolio._id);
  };
  const onKeyPress = ({ key }) => {
    if (key === "Enter") {
      openGallery();
    }
  };
  return (
    <S.Wrap
      onClick={openGallery}
      aria-label={portfolio.desc}
      tabIndex="0"
      onKeyPress={onKeyPress}
      role="button"
    >
      <S.Pic src={generateUrl(portfolio.photo)} />
    </S.Wrap>
  );
};
PortfolioFeedItem.propTypes = {
  portfolio: PT.object,

  openGallery: PT.func.isRequired,
};
export default PortfolioFeedItem;
